import { patterns } from '@/components/card/constants';

export function getRandomPattern() {
  return patterns[getRandomIntInclusive(0, patterns.length - 1)];
}

export function getDeterministicPattern(index: number) {
  return patterns[index];
}

function getRandomIntInclusive(min: number, max: number) {
  const minCeil = Math.ceil(min);
  const maxFloor = Math.floor(max);
  return Math.floor(Math.random() * (maxFloor - minCeil + 1) + minCeil);
}
